<template>
  <div class="auth-form">
    <auth-form-layout-builder
      :rules="rules"
      :full-form-data="fullFormData"
    >
      <!-- If rules apply, put each attribute in its own slot -->
      <template
        v-for="attribute in attributes"
        v-slot:[`field-${attribute.key}`]="{ props }"
      >
        <auth-form-field-attribute
          :attribute="attribute"
          :key="attribute.key"
          :custom-props="props"
          :bool-has-defined-title="boolHasDefinedTitle"
          :selected-country="selectedCountry"
          @setAttribute="setAttribute"
        />
      </template>
      <!-- If no rules apply, put everything in the default slot -->
      <template v-if="rulesAreEmpty">
        <template v-for="attribute in attributes">
          <auth-form-field-attribute
            :attribute="attribute"
            :key="attribute.key"
            :bool-has-defined-title="boolHasDefinedTitle"
            :selected-country="selectedCountry"
            @setAttribute="setAttribute"
          />
        </template>
      </template>
    </auth-form-layout-builder>
  </div>
</template>

<script>
  import _ from 'lodash';
  import setBlankTargetForLinks from '@/utils/auth/setBlankTargetForLinks';
  import AuthFormLayoutBuilder from './AuthFormLayoutBuilder';
  import AuthFormFieldAttribute from './AuthFormFieldAttribute';

  export default {
    name: "AuthForm",
    props: {
      attributes: {
        type: Array,
        required: true,
      },
      rules: {
        type: Object,
        default: () => {},
      },
      boolHasDefinedTitle: {
        type: Boolean,
        default: false,
      },
      fullFormData: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      AuthFormLayoutBuilder,
      AuthFormFieldAttribute
    },
    data: () => ({
      requestBody: {
        custom_fields: []
      }
    }),
    computed: {
      rulesAreEmpty() {
        return _.isEmpty(this.rules)
      },
      selectedCountry() {
        if (_.isEmpty(this.fullFormData)) {
          return ''
        }

        const customFields = _.get(
          this.fullFormData,
          'custom_fields',
          []
        )

        if (_.isEmpty(customFields)) {
          return ''
        }

        const country = customFields.find((field) => {
          return field.key === 'country'
        })

        if (!country) {
          return ''
        }

        return _.get(country, 'value', '')
      }
    },
    mounted() {
      setBlankTargetForLinks(document.querySelector('.auth-form'));
    },
    methods: {
      setName(name) {
        if (!_.isEmpty(name.firstName) && !_.isEmpty(name.lastName)) {
          this.$set(this.requestBody, 'first_name', name.firstName);
          this.$set(this.requestBody, 'last_name', name.lastName);
        }
      },
      setAttribute(attr) {
        if (attr.identity === 'custom_fields') {
          if (!(attr.identity in this.requestBody)) {
            this.$set(this.requestBody, attr.identity, []);
          }
          const customFieldIndex = this.requestBody.custom_fields.findIndex((element) => element.key === attr.key);
          if (customFieldIndex >= 0) {
            this.$set(this.requestBody.custom_fields, customFieldIndex, {key: attr.key, value: attr.value});
          } else {
            this.requestBody.custom_fields.push({key: attr.key, value: attr.value});
          }
        } else if (attr.identity) {
          if (!(attr.identity in this.requestBody)) {
            this.$set(this.requestBody, attr.identity, {});
          }
          this.$set(this.requestBody[attr.identity], attr.key, attr.value);
        } else {
          if (attr.key === 'phone') {
            this.$set(this.requestBody, 'phone_number', attr.value);
          } else {
            this.$set(this.requestBody, attr.key, attr.value);
          }
        }
      }
    },
    watch: {
      requestBody: {
        handler() {
          this.$emit('setRequestBody', this.requestBody);
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped></style>
